<script>
    import Top from './Top.svelte';
    import Btm from './Btm.svelte';
    import Icon from 'fa-svelte';
    import { cmp,rnd } from './store.js';
    import { onMount } from 'svelte';
    import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
    import { faWalking } from '@fortawesome/free-solid-svg-icons';

    let walk = faWalking;
    let won = faCheckCircle;
    let hdrs = ['Mick Lewin Trophy','Albert Rowlett Cup','Munday Shield'];
    let rules= ['3R - 3P - 3W - 18 Ends','3R - 3P - 2W - 21 Ends',' (H&A) - 4P - 2W - 21 Ends'];
    let data = [];

    async function getCmp() {
       let response = await fetch(`https://www.bowls-league.com/mobile/comps${$cmp}.json`);
       let dta = await response.json();
       data =  dta[$rnd];
      }
  
    onMount (() => {getCmp()});
</script>

<style>
.container {
    display:grid;
    grid-template-columns:10% 37% 8% 8% 37%}

.hdr {
    background:tan;
    border:1px solid #000000cc;
    padding:2px;
    text-align:left;
}

.item {
    border:1px solid rgba(0, 0, 0, 0.8);
    padding:4px;
    text-align:left
}

.trn {
    border:1px solid #000000cc;
    padding:2px;
    text-align:left;
}

h3 {
    text-align: center;
    margin: 0 0 0 0;
    line-height: 1.5;
    padding: 2px;
    background-color: mistyrose
}
</style>

  <header class="header">
    <Top on:CmpUpd={getCmp}/>
  </header>
  <section >
   <h3>{hdrs[$cmp-9]}<br/>{rules[$cmp-9]}</h3>
   <div class="container">
      {#each data as field}
        <div class="{field.b}">{field.p}</div>
        <div class="{field.b}">{field.h}
        {#if field.s > field.t}
           <Icon icon={won} size="sm"/>
        {/if}
        </div>
        {#if field.s==='W/O'} 
            <Icon icon={walk} size="sm"/>
        {:else}
           <div class="{field.b}">{field.s}</div>
        {/if}
        {#if field.t==='W/O'} 
           <Icon icon={walk} size="sm"/>
        {:else}
           <div class="{field.b}">{field.t}</div>
        {/if}
        <div class="{field.b}">{field.a}
        {#if field.t > field.s}
           <Icon icon={won} size="sm"/>
        {/if}
        </div> 
      {/each}
   </div>
   <p>Symbol Keys : <Icon icon={won} size="sm"/>&nbsp;Winner -- Conceded&nbsp;&nbsp;<Icon icon={walk} size="sm"/></p>
   </section>
   <footer class="header">
     <Btm on:CmpUpd={getCmp}/>
   </footer>